var READ = {
    loadContent: "#app",
    ProjectDateRange: async function(component, dataAPI) {
        return await dataAPI.Read.ProjectDateRange().then(async response => {
            return response.data;
        }).catch(function() { READ.Errors.Set(component, "Project Date Range"); });
    },
    ProjectByProjectID: async function(component, dataAPI, projectID) {
        return await dataAPI.Read.ProjectByProjectID(projectID).then(async response => {
            return response.data;
        }).catch(function() { READ.Errors.Set(component, "Project"); });
    },
    ProjectListByCategory: async function(component, dataAPI) {
        return await dataAPI.Read.ProjectListByCategory().then(async response => {
            return response.data;
        }).catch(function() { READ.Errors.Set(component, "Project List by Primary Type"); });
    },
    TimelineData: async function(component, dataAPI) {
        return await dataAPI.Read.TimelineData().then(async response => {
            return response.data;
        }).catch(function() { READ.Errors.Set(component, "Timeline Data"); });
    },
    Counts: async function(component, dataAPI) {
        return await dataAPI.Read.Counts().then(async response =>  {
            return response.data;
        }).catch(function() { READ.Errors.Set(component, "Counts"); })
    },
    DistinctTypes: async function(component, dataAPI) {
        return await dataAPI.Read.DistinctTypes().then(async response =>  {
            return response.data;
        }).catch(function() { READ.Errors.Set(component, "Distinct Types"); })
    },
    ProjectTypes: async function(component, dataAPI) {
        return await dataAPI.Read.ProjectTypes().then(async response =>  {
            return response.data;
        }).catch(function() { READ.Errors.Set(component, "Project Types"); })
    },
    AnalysisUsageProfile: async function(component, dataAPI) {
        return await dataAPI.Read.AnalysisUsageProfile().then(async response =>  {
            return response.data;
        }).catch(function() { READ.Errors.Set(component, "Analysis Usage Profile"); })
    },
    Accolades: async function(component, dataAPI) {
        return await dataAPI.Read.Accolades().then(async response =>  {
            return response.data;
        }).catch(function() { READ.Errors.Set(component, "Accolades"); })
    },
    AccoladeByAccoladeID: async function(component, dataAPI, accoladeID) {
        return await dataAPI.Read.AccoladeByAccoladeID(accoladeID).then(async response =>  {
            return response.data;
        }).catch(function() { READ.Errors.Set(component, "Accolade"); })
    },
    Errors: {
        list: [],
        Set: function(component, area) {
            this.list.push(area);
            component.dataErrors = this.list;
        }
    }
};

module.exports = { READ };